import { Container, Opcao, TextoOpcao } from "./style";

interface Props {
  aberto: boolean;
  onClickResumido: () => void;
  onClickDetalhado: () => void;
}

export function OpcoesExportar({
  aberto,
  onClickResumido,
  onClickDetalhado,
}: Props) {
  return (
    <Container aberto={aberto}>
      <div>
        <Opcao>
          <TextoOpcao onClick={onClickResumido}>Relatório resumido</TextoOpcao>
        </Opcao>
        <Opcao>
          <TextoOpcao onClick={onClickDetalhado}>
            Relatório detalhado
          </TextoOpcao>
        </Opcao>
      </div>
    </Container>
  );
}
